define('features/slp/page',[
  'require', // contains BATNext
  'jquery',
  'lib/page-cache',
  'features/recentVehicles',
  'lib/getParameterByName',
  'lib/services/batws',
  'lib/transforms/dealer.tmpl.common',
  'lib/util/zip',
  // 'facebook',
  'detectizr',
  'lib/util/tda.config',
  'lib/services/offers-service',
  'lib/transforms/offers.tmpl.common',
  'lib/util/langFromUrl',
  'cookies',
  'lib/transforms/slp.offer.comment',
  'lib/transforms/slp.series',
  'lib/animations/offers.animations',
  'bat',

  // Side Effect Includes
  'lib/helpers/offer-bundle',
  'jqueryui',
  'lib/loader/series',
  'lib/transforms/series.byCategory'
], function (
  require,
  $,
  PageCache,
  recentVehicles,
  paramByName,
  batws,
  xformDealersCommon,
  zip,
  // facebook,
  detectizr,
  tdaConfig,
  offersServiceFactory,
  xformOffersCommon,
  langFromUrl,
  cookies,
  slpOfferComment,
  slpSeries,
  offersAnimations,
  bat
) {
  // Dynamically require BAT Next
  var BATNext;
  var facebook;
  var offersService = offersServiceFactory(tdaConfig.offers.r2_api_key);

  // When a USLP page has an offer with it,
  // we need to format the series associated w/ the offer
  function __formatSeriesFromOffer(seriesList) {
    if (seriesList.series.length) {
      var year = seriesList.series[0].year;
      var names = seriesList.series[0].id.split(',');
      var mapped = names.map(function (name) { return year + '|' + name; });
      return mapped.join(',');
    }
    return seriesList.series.year + '|' + seriesList.series.id;
  }

  var SLPPage = function (el, opts) {
    this.opts = opts;
    this.el = el;
    // Moved out of XSL based depends for webpack purposes
    this.opts.tdaConfig = tdaConfig;
    this.opts.i18n.legalCopy = this.opts.i18n.legalCopy.replace('%1', tdaConfig.site.context_url);
  };

  $.extend(SLPPage.prototype, {
    load: function () {
      var self = this;
      var cacheIds = ['series.byCategory.all'];
      var offerId = paramByName('offerId');

      if (offerId.length) {
        cacheIds.push('offer.' + offerId);
        self.getOffer(offerId);
        self.hasOffer = true;
      }

      PageCache.awaitAll(cacheIds)
        .then(function (res) {
          if (offerId) {
            return new Promise(function (resolve, reject) {
              if (res[1].containsOffers) {
                xformOffersCommon(res[1].offerBundle.offers)
                  .then(function (xformed) {
                    var $template = $('#template-offer-card');
                    var handlebarsHTML = Handlebars.hcompile($template.html(), { items: xformed });
                    self.opts.offerHtml = handlebarsHTML;
                    self.opts.offerComment = slpOfferComment(res[1].offerBundle.offers[0]);
                    self.opts.series = __formatSeriesFromOffer(res[1].offerBundle.offers[0].seriesList);
                    resolve([res[0]]);
                  }, reject);
              } else {
                console.warn('Offers query did not containOffers');
                resolve([res[0]]);
              }
            });
          }
          return res;
        })
        .then(function (res) {
          return new Promise(function (resolve, reject) {
            require(['bat-next'], function (BATNextLib) {
              BATNext = BATNextLib;
              resolve(res);
            }, reject);
          });
        })
        .then(function (res) {
          return new Promise(function (resolve, reject) {
            require(['vendor/facebook/sdk'], function () {
              facebook = window.FB;
              resolve(res);
            }, reject);
          });
        })
        .then(function (res) {
          self.drawParent(res[0]);
        })
        .catch(function (err) { console.error('error in pageCache: ', err); });
    },

    getOffer: function (offerId) {
      var cacheId = 'offer.' + offerId;

      // If we don't already have a pending request or current value, fetch it
      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        var request = {
          tdaCode: tdaConfig.tda.code,
          zipCode: zip.getCookiedDefaultFallback(),
          offerId: offerId,
          lang: langFromUrl
        };
        PageCache.maybeSet(cacheId, offersService.offers().byOfferId(request));
      }
    },

    drawParent: function (series) {
      var self = this;
      var defaultZip = cookies.getItem('isConfirmedZip') === 'true' ? zip.getCookiedDefaultFallback() : '';
      var formLength = this.opts.formLength === 'default' ? 'long' : this.opts.formLength;
      var dealersStore = new BATNext.Store.DealersStore.createDefaultDealersStore(batws, xformDealersCommon);
      var formStore = new BATNext.SLP.FormStore({
        submit: function (model) {
          var req = Object.assign({
            successPage: window.location.origin + '/' + tdaConfig.site.context_url + '/request-a-quote/thankyou/',
            errorPage: window.location.origin + '/' + tdaConfig.site.context_url + '/request-a-quote/404/',
          }, model);

          if (req.series && req.series.length) {
            var xformedSeries = slpSeries(req.series);
            if (xformedSeries.moreSeries) {
              req.comments = (req.comments || '') + xformedSeries.moreSeries;
              delete xformedSeries.moreSeries;
            }
            Object.assign(req, xformedSeries);
            delete req.series;
          }
          if (req.offerComment) {
            req.comments = (req.comments || '') + '\n\n:::' + req.offerComment;
          }
          var updatedModel = Object.assign(model, req);
          return batws.slp().getQuote(req)
            .then(function () {
              return updatedModel;
            });
        }
      }, Object.assign({}, {
        vehicleMake: 'N/A',
        vehicleModel: 'N/A',
        vehicleYear: 'N/A',
        preferedContact: 'email',
        slpType: this.opts.slpType,
        zip: defaultZip,
        selectedDealer: 'zip',
        deviceType: detectizr.device.type,
        omnitureId: cookies.getItem('xact'),
        mediaTag: cookies.getItem('campaign'),
        tmsSiteAttribute: cookies.getItem('TMSSiteAttr')
      }, this.opts.hiddenFields), formLength, detectizr.device.type);
      formStore.setLang(this.opts.i18n.lang);

      var defaultOpts = {
        recentSeries: recentVehicles.getVehicles(),
        seriesByCategory: series,
        defaultZip: defaultZip,
        facebook: facebook,
        dealersStore: dealersStore,
        formStore: formStore
      };

      switch (this.opts.slpType) {
        case 'cad':
          BATNext.SLP.renderCAD(this.el, $.extend({}, defaultOpts, this.opts));
          break;
        case 'satd':
          BATNext.SLP.renderSATD(this.el, $.extend({}, defaultOpts, this.opts));
          break;
        default:
          BATNext.SLP.renderRAQ(this.el, $.extend({}, defaultOpts, this.opts));
          break;
      }

      if (self.hasOffer) {
        offersAnimations.animateOfferCards();
      }
      bat.util.loader.hideLoader();
    }
  });

  return SLPPage;
});

